export default "__VITE_ASSET__6feffbb6__"